import React, { useState, useEffect, useContext } from "react";
import FadeIn from "react-fade-in";
import { useLocation, useNavigate } from "react-router-dom";
import RecipeCard from "../../../../InterstellrComponents/RecipeCard";
import { UserContext } from "../../../../storage/contexts/UserContext";
import { GET_CATEGORY_RECIPES } from "../../../../Routes";
import { generateURLOptions } from "../../../../URLOptions";

import { FaChevronLeft } from "react-icons/fa6";

import axios from "axios";

const SingleRecipeCategory = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { profile } = useContext(UserContext);

  const [visible, setVisible] = useState(true);
  const [category, setCategory] = useState({});

  useEffect(() => {
    console.log(state);

    if (state.categoryId) {
      getRecipes();
    }
  }, []);

  const getRecipes = async () => {
    await axios
      .get(GET_CATEGORY_RECIPES + state?.categoryId, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        console.log("Recipe Category Data: ", response);
        setCategory(response.data?.data);
      })
      .catch((error) => {
        console.log("Get Recipe Category Data Error: ", error);
        return alert(error);
      });
  };

  const navigateBack = () => {
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/recipes");
    }, 350);
  };

  const viewRecipe = (data) => {
    console.log("Tapped Recipe", data);
    setVisible(false);
    setTimeout(() => {
      navigate("/wellness/recipes/details", {
        state: {
          recipeId: data?._id,
        },
      });
    }, 500);
  };

  return (
    <>
      <div
        className="w-screen min-h-[90vh]"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <FadeIn delay={200} visible={visible}>
          <div className="container mx-auto flex flex-col justify-start items-center h-full w-full">
            <div className="mt-12 w-full px-6 md:px-0">
              <h4 className="text-2xl font-semibold">
                {category?.name ?? "Eat well 🍎"}
              </h4>

              <div
                onClick={navigateBack}
                className="flex flex-row justify-start items-center cursor-pointer mt-2"
              >
                <FaChevronLeft />
                <p className="text-black font-medium text-sm ml-2">Back</p>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 md:gap-4 mt-6">
                {category?.recipes?.map((recipe) => (
                  <RecipeCard
                    key={recipe._id}
                    recipe={recipe}
                    onClick={viewRecipe}
                  />
                ))}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </>
  );
};

export default SingleRecipeCategory;
